<template>
    <div class="main" :style="{ backgroundImage: `url(${bgImageUrl})`, '--themeColor': themeColor }">

        <div class="mask-div" :style="{ opacity: showMask && project ? maskOpacity : 0 }"></div>

        <div class="content-div" style="position: absolute;z-index: 3;">

            <el-button type="info" @click="showChoiceMatchDialog" style="position: absolute;top: 20px;right: 20px;
       z-index: 1000;opacity: 0.5;font-size: 20px" circle icon="el-icon-setting"></el-button>
            <!-- <img src="../../../assets/images/set.png" style="position: absolute;top: 50px;right: 40px;
        width: 100px;height: 50px;cursor: pointer;z-index: 1000;" alt="" @click="showChoiceMatchDialog"> -->

            <div class="match-title-div">
                <div class="match-title" :style="{ fontSize: `${matchTitleFontSize}px` }">
                    {{ matchName }}
                </div>
            </div>
            <div class="project-info-div" v-if="project && project.ProjectName"
                :style="{ fontSize: `${proTitleFontSize}px` }">
                项目： {{ project.ProjectName }}
            </div>
            <div class="user-score-div" v-if="project">
                <!--花样赛、集体自编赛-->
                <el-carousel :interval="carouselSpeed" arrow="always" height="700px" v-if="project.ProjectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D'
                    || project.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C'
                    || project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                    || project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
                    || project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
                    || project.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
                    || project.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'
                    || project.ProjectTypeId == 'EC5B512C-37BC-46F4-BFD3-7C5FF3086F14'
                    || project.ProjectTypeId == '5874F99D-0D4F-49F6-A3A6-BE4867F652B8'
                    || project.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
                ">
                    <el-carousel-item v-for="item in userScores">
                        <!--花样/体积自编，显示单人-->
                        <div class="pattern-div" v-if="false">
                            <div class="user-info">
                                <div class="image-div">
                                    <img v-if="item.UnitLogoFilePath && showUnitLogo"
                                        :src="fileRootPath + item.UnitLogoFilePath" alt="">
                                    <img v-else src="../../../assets/default-header-icon.png" alt="">
                                </div>
                                <div class="unit-div">
                                    <span>{{ item.Unit }}</span>
                                </div>
                                <div class="username-div">
                                    <span>{{ item.UserName }}</span>
                                </div>
                                <div class="group-div">
                                    <span>{{ item.ComeOnGroup }}组{{ item.ComeOnNum }}号</span>
                                </div>
                            </div>
                            <div class="score-group">
                                <div class="score-group-item"
                                    style="border-right: 1px solid #e3e3e3;border-bottom: 1px solid #e3e3e3;">
                                    <div class="title">难度</div>
                                    <div class="value">{{ item.D_Score }}</div>
                                </div>
                                <div class="score-group-item"
                                    style="border-left: 1px solid #e3e3e3;border-bottom: 1px solid #e3e3e3;">
                                    <div class="title">表现</div>
                                    <div class="value">{{ item.P_Score }}</div>
                                </div>
                                <div class="score-group-item"
                                    style="border-right: 1px solid #e3e3e3;border-top: 1px solid #e3e3e3;">

                                    <div class="value">{{ item.M_Score }}</div>
                                    <div class="title">失误</div>
                                </div>
                                <div class="score-group-item"
                                    style="border-left: 1px solid #e3e3e3;border-top: 1px solid #e3e3e3;">
                                    <div class="value"
                                        v-if="project.ProjectTypeId != '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'">{{
                                            item.Q_Score }}</div>
                                    <div class="title"
                                        v-if="project.ProjectTypeId != '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'">规定</div>
                                </div>
                            </div>
                            <div class="score-result">
                                <div class="title">
                                    <span>总分</span>
                                </div>
                                <div class="score-num">
                                    <span>{{ item.FinalTotalScore }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="pattern-div2">
                            <div class="left-div">
                                <div class="group-div">
                                    <span>{{ item.ComeOnGroup }}组{{ item.ComeOnNum }}号</span>
                                </div>
                                <div class="user-info">
                                    <div class="image-div">
                                        <img v-if="item.UnitLogoFilePath && showUnitLogo" style="border-radius: 50%;"
                                            :src="fileRootPath + item.UnitLogoFilePath" alt="">
                                        <img v-else src="../../../assets/default-header-icon.png" alt=""
                                            style="border-radius: 50%;">
                                    </div>
                                    <div class="text-div">
                                        <div class="unit-div">
                                            <span>{{ item.Unit }}</span>
                                        </div>
                                        <div class="username-div"
                                            style="position: relative; display: flex;flex-wrap: wrap; width: 100%;">
                                            <div v-for="athlete in item.AthleteSnapshots"
                                                style="position: relative; width:15%; ">
                                                <div style="position: relative;text-align: center;">
                                                    <img style="border-radius: 50%;width: 60px;height: 60px;"
                                                        v-if="athlete.UserPhotoFiles && showUnitLogo"
                                                        :src="fileRootPath + athlete.UserPhotoFiles[0].FilePath" alt="">
                                                    <img style="width: 60px;height: 60px;" v-else
                                                        src="../../../assets/default-header-icon.png" alt="">
                                                </div>
                                                <div style="font-size:16px;text-align: center;">{{ athlete.UserName }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="score-group">
                                    <div class="score-group-item" style="border-right: 1px solid #e3e3e3;">
                                        <div class="title">难度</div>
                                        <div class="value">{{ item.D_Score }}</div>
                                    </div>
                                    <div class="score-group-item" style="border-right: 1px solid #e3e3e3;">
                                        <div class="title">表现</div>
                                        <div class="value">{{ item.P_Score }}</div>
                                    </div>
                                    <div class="score-group-item" style="border-right: 1px solid #e3e3e3;">
                                        <div class="title">失误</div>
                                        <div class="value">{{ item.M_Score }}</div>
                                    </div>
                                    <div class="score-group-item" style="">
                                        <div class="title"
                                            v-if="project.ProjectTypeId != '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'">规定
                                        </div>
                                        <div class="value"
                                            v-if="project.ProjectTypeId != '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'">{{
                                                item.Q_Score }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="right-div">
                                <div class="score-result">
                                    <div class="title">
                                        <span>总分</span>
                                    </div>
                                    <div class="score-num">
                                        <span>{{ item.FinalTotalScore }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>

                <!-- 国内花样赛、国内表演赛-->
                <el-carousel :interval="carouselSpeed" arrow="always" height="700px" v-if="project.ProjectTypeId == '39E56A5E-CB75-4245-AA8C-C0553C6C4ADF'
                    || project.ProjectTypeId == '528D50AF-3268-45B7-A0B2-6C25D6759095'
                    || project.ProjectTypeId == 'A66C8472-C5D5-4C66-85AD-7B2ABF1D680A'
                ">
                    <el-carousel-item v-for="item in userScores">
                        <!--花样/体积自编，显示单人-->
                        <div class="pattern-div" v-if="false">
                            <div class="user-info">
                                <div class="image-div">
                                    <img v-if="item.UnitLogoFilePath && showUnitLogo"
                                        :src="fileRootPath + item.UnitLogoFilePath" alt="">
                                    <img v-else src="../../../assets/default-header-icon.png" alt="">
                                </div>
                                <div class="unit-div">
                                    <span>{{ item.Unit }}</span>
                                </div>
                                <div class="username-div">
                                    <span>{{ item.UserName }}</span>
                                </div>
                                <div class="group-div">
                                    <span>{{ item.ComeOnGroup }}组{{ item.ComeOnNum }}号</span>
                                </div>
                            </div>
                            <div class="score-group">
                                <div class="score-group-item"
                                    style="border-right: 1px solid #e3e3e3;border-bottom: 1px solid #e3e3e3;">
                                    <div class="title">难度</div>
                                    <div class="value">{{ item.D_Score }}</div>
                                </div>
                                <div class="score-group-item"
                                    style="border-left: 1px solid #e3e3e3;border-bottom: 1px solid #e3e3e3;">
                                    <div class="title">完成质量</div>
                                    <div class="value">{{ item.CQ_Score }}</div>
                                </div>
                                <div class="score-group-item"
                                    style="border-right: 1px solid #e3e3e3;border-top: 1px solid #e3e3e3;">
                                    <div class="value">{{ item.CA_Score }}</div>
                                    <div class="title">创意编排</div>
                                </div>
                                <div class="score-group-item"
                                    style="border-left: 1px solid #e3e3e3;border-top: 1px solid #e3e3e3;">
                                    <div class="value">{{ item.Q_Score }}</div>
                                    <div class="title">规定</div>
                                </div>
                            </div>
                            <div class="score-result">
                                <div class="title">
                                    <span>总分</span>
                                </div>
                                <div class="score-num">
                                    <span>{{ item.FinalTotalScore }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="pattern-div2">
                            <div class="left-div">
                                <div class="group-div">
                                    <span>{{ item.ComeOnGroup }}组{{ item.ComeOnNum }}号</span>
                                </div>
                                <div class="user-info">
                                    <div class="image-div">
                                        <img v-if="item.UnitLogoFilePath && showUnitLogo"
                                            :src="fileRootPath + item.UnitLogoFilePath" alt="">
                                        <img v-else src="../../../assets/default-header-icon.png" alt="">
                                    </div>
                                    <div class="text-div">
                                        <div class="unit-div">
                                            <span>{{ item.Unit }}</span>
                                        </div>
                                        <div class="username-div"
                                            style="position: relative; display: flex;flex-wrap: wrap; width: 100%;">
                                            <div v-for="athlete in item.AthleteSnapshots"
                                                style="position: relative; width:15%; ">
                                                <div style="position: relative;text-align: center;">
                                                    <img style="border-radius: 50%;width: 60px;height: 60px;"
                                                        v-if="athlete.UserPhotoFiles && showUnitLogo"
                                                        :src="fileRootPath + athlete.UserPhotoFiles[0].FilePath" alt="">
                                                    <img style="width: 60px;height: 60px;" v-else
                                                        src="../../../assets/default-header-icon.png" alt="">
                                                </div>
                                                <div style="font-size:16px;text-align: center;">{{ athlete.UserName }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="score-group">

                                    <div class="score-group-item" style="border-right: 1px solid #e3e3e3;">
                                        <div class="title">难度</div>
                                        <div class="value">{{ item.D_Score }}</div>
                                    </div>
                                    <div class="score-group-item" style="border-right: 1px solid #e3e3e3;">
                                        <div class="title">完成质量</div>
                                        <div class="value">{{ item.CQ_Score }}</div>
                                    </div>
                                    <div class="score-group-item" style="border-right: 1px solid #e3e3e3;">
                                        <div class="title">创意编排</div>
                                        <div class="value">{{ item.CA_Score }}</div>
                                    </div>
                                    <div class="score-group-item" style="">
                                        <div class="title">规定</div>
                                        <div class="value">{{ item.Q_Score }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="right-div">
                                <div class="score-result">
                                    <div class="title">
                                        <span>总分</span>
                                    </div>
                                    <div class="score-num">
                                        <span>{{ item.FinalTotalScore }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>

                <!--竞速、规定-->
                <el-carousel :interval="carouselSpeed" direction="vertical" arrow="always" height="800px" v-if="project.ProjectTypeId == 'F679B7E4-F852-4A2A-BAF2-EC21BE923826'
                    || project.ProjectTypeId == '7427106A-8F3D-4990-803E-C10B92ED618F'
                    || project.ProjectTypeId == 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3'">

                    <el-carousel-item v-for="page in speechUserScore">
                        <div class="speed-div" :style="{ width: speedDivWidth }">
                            <div class="user-item" v-for="item in page" :style="{ width: speedUserItemDivWidth }">
                                <div class="user-score-detail" v-if="item.UserId">
                                    <div class="group-div">
                                        <span>{{ item.ComeOnGroup }}组{{ item.ComeOnNum }}号</span>
                                    </div>
                                    <div class="unit-div">
                                        <span>{{ item.Unit }}</span>
                                    </div>
                                    <div class="user-score-detail-body">
                                        <div class="user-detail">

                                            <div class="username-div"
                                                style="position: relative; display: flex;flex-wrap: wrap; width: 100%;">
                                                <div v-for="athlete in item.AthleteSnapshots"
                                                    style="position: relative; width:15%; ">
                                                    <div
                                                        style="position: relative;text-align: center;width:100%;height: 50px;">
                                                        <img style="border-radius: 50%;width: 38px;height: 38px;"
                                                            v-if="athlete.UserPhotoFiles && showUnitLogo"
                                                            :src="fileRootPath + athlete.UserPhotoFiles[0].FilePath"
                                                            alt="">
                                                        <img style="width: 38px;height: 38px;" v-else
                                                            src="../../../assets/default-header-icon.png" alt="">
                                                    </div>
                                                    <div style="text-align: center;">{{ athlete.UserName }}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="score-num-div">{{ item.FinalTotalScore }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>

                <el-carousel :interval="carouselSpeed" direction="vertical" arrow="always" style="height: 600px;" v-if="project.ProjectTypeId == 'A8CF0C94-4A2B-495C-8E4C-861357928917'
                    || project.ProjectTypeId == 'B5F1B35F-FD39-4F5D-83CA-9972A21BC8C1'
                    || project.ProjectTypeId == 'FA8BBD50-62E3-47A0-A611-F70D34F29A67'
                ">
                    <el-carousel-item v-for="page in speechUserScore">
                        <div class="rule-div" :style="{ width: speedDivWidth }">
                            <div class="user-item" v-for="item in page" :style="{ width: speedUserItemDivWidth }">
                                <div class="user-score-detail" v-if="item.UserId" style="display: flex;">
                                    <div class="user-info">
                                        <div class="unit-div">
                                            <span>{{ item.Unit }}</span>
                                        </div>
                                        <div class="username-div">
                                            <span>{{ item.UserName }}</span>
                                        </div>
                                        <div class="group-div">
                                            <span>{{ item.ComeOnGroup }}组{{ item.ComeOnNum }}号</span>
                                        </div>
                                    </div>
                                    <div class="score-item-div">
                                        <div class="score-item">
                                            <p>创意编排</p>
                                            <div class="score-num-div">{{ item.CA_Score }}</div>
                                        </div>
                                        <div class="score-item">
                                            <p>完成质量</p>
                                            <div class="score-num-div">{{ item.CQ_Score }}</div>
                                        </div>
                                        <div class="score-item">
                                            <p>总分</p>
                                            <div class="score-num-div">{{ item.FinalTotalScore }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>


            <el-dialog title="设置" :modal="false" :visible.sync="choiceMatchDialogVisible" :close-on-press-escape="true"
                :show-close="true" width="800px">
                <div style="width: 80%;margin: 0 auto;">
                    <el-form label-width="150px" label-suffix=":" label-position="left">
                        <el-form-item label="赛事">
                            <el-select clearable filterable remote reserve-keyword placeholder="请输入关键词" size="small"
                                @change="matchSelectChange" :remote-method="remoteMethod" v-model="matchId">
                                <el-option v-for="item in matchOptions" :label="item.MatchName" :value="item.MatchId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="赛场">
                            <el-radio-group v-if="regionOptions" v-model="regionId">
                                <el-radio style="margin-bottom: 10px;" v-for="r in regionOptions" :label="r.RegionId">{{
                                    r.RegionName }}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="轮询速度(毫秒)">
                            <el-input-number size="mini" v-model="editCarouselSpeed" :min="1000"
                                :step="1000"></el-input-number>
                        </el-form-item>
                        <el-form-item label="成绩刷新速度(毫秒)">
                            <el-input-number size="mini" v-model="editScoreIntervalTime" :min="1000"
                                :step="1000"></el-input-number>
                        </el-form-item>
                        <el-form-item label="显示单位Logo/运动员照片">
                            <el-switch v-model="editShowUnitLogo" active-color="#13ce66" inactive-color="#ff4949">
                            </el-switch>
                        </el-form-item>
                        <el-form-item label="显示蒙层">
                            <el-switch v-model="editShowMask" active-color="#13ce66" inactive-color="#ff4949">
                            </el-switch>
                        </el-form-item>
                        <el-form-item label="蒙层透明度">
                            <el-input-number size="mini" v-model="editMaskOpacity" :min="0" :max="1"
                                :step="0.1"></el-input-number>
                        </el-form-item>
                        <el-form-item label="赛事名称字体大小">
                            <el-input-number size="mini" v-model="editMatchTitleFontSize" :min="12"></el-input-number>
                        </el-form-item>
                        <el-form-item label="项目名称字体大小">
                            <el-input-number size="mini" v-model="editProTitleFontSize" :min="12"></el-input-number>
                        </el-form-item>

                        <el-form-item label="主题颜色">
                            <el-color-picker v-model="editThemeColor"></el-color-picker>
                        </el-form-item>
                    </el-form>
                </div>

                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" size="small" @click="confirmChoiceMatch">确定</el-button>
                </span>
            </el-dialog>
        </div>
        <div>
            {{ scores }}
        </div>
    </div>
</template>

<script>
import MatchService from '@/request-server/request-services/match-services.js';
import SystemService from '@/request-server/request-services/system-services.js';
import Common from '@/utils/utils-common.js';
import BrowserStorage from '@/utils/utils-browser-storage.js';
import Url from '@/request-server/request-url';
import { buildConnection } from '@/utils/signalr';
export default {
    data() {
        return {
            routerMatchId: '',
            routerRegionId: '',
            speedUserItemDivWidth: '25%',
            speedDivWidth: '100%',
            matchId: '',
            regionId: '',
            editCarouselSpeed: 5000,
            editShowUnitLogo: true,
            editShowMask: true,
            editMaskOpacity: 0.5,
            editScoreIntervalTime: 3000,
            editThemeColor: '#0030b3',
            editMatchTitleFontSize: 50,
            editProTitleFontSize: 30,
            allMatchs: [],
            matchOptions: [],
            regionOptions: [],
            matchName: '',
            match: { MatchName: '' },
            project: { ProjectName: '', GroupName: '', GenderRuleText: '' },
            userScores: [],
            speechUserScore: [],
            choiceMatchDialogVisible: false,
            interval: null,
            carouselSpeed: 5000,
            showUnitLogo: true,
            showMask: true,
            maskOpacity: 0.5,
            fileRootPath: '',
            bgImageUrl: require('@/assets/images/screen-mirroring-bg.png'),
            scoreIntervalTime: 3000,
            themeColor: '#0030b3',
            matchTitleFontSize: 50,
            proTitleFontSize: 30,
            isConnected: false,
            connection: null,
            scores: {}
        }

    },
    watch: {
        $route(to, from) {
            this.initData();
        },
    },
    beforeDestroy() {
        this.stopPollGetUserScore();
        if (this.connection) {
            this.connection.off('ReceiveScoreUpdate');
            this.connection.off('ReceiveAllScores');
            this.connection.stop();
        }
    },
    mounted() {
        this.initSignalR();
    },
    created() {
        this.initData();
        this.startPollGetUserScore();
        this.fileRootPath = Url.getDownloadBaseUrl() + 'uploadfiles/';
    },
    methods: {

        async initSignalR() {
            this.connection = buildConnection();

            // 1. 监听全量分数（连接时触发）
            this.connection.on('ReceiveAllScores', (allScores) => {
                // 初始化或重置所有分数
                //console.log(allScores);
                //this.scores = allScores;
            });

            // 2. 监听单条分数更新（每次提交后触发）
            this.connection.on('ReceiveScoreUpdate', (region, userId, score) => {
                // 使用 $set 确保 Vue 2 响应式更新
                console.log(region, userId, score);
                console.log("当前赛场ID", this.routerRegionId);
                if (region == this.routerRegionId) {
                    this.userScores.forEach(item => {
                        if (item.UserId == userId) {
                            item.FinalTotalScore = score;
                            console.log("更新用户分数", item);
                        }
                    })
                }
            });

            try {
                await this.connection.start();
                this.isConnected = true;
            } catch (err) {
                console.error('SignalR connection failed:', err);
                this.isConnected = false;
                //   ElMessage.error('无法连接到评分服务，请刷新页面重试');
            }
        },
        initData() {
            console.log('initData');
            this.getAllMatchs();
            let mid = this.$route.params.mid;
            console.log(mid)
            if (mid) {
                this.routerMatchId = mid;
                this.matchId = mid;
                this.getMatchDetail();
            }

            let value = BrowserStorage.getItem('carouselSpeed');
            this.carouselSpeed = value ? parseInt(value) : 5000;
            this.editCarouselSpeed = this.carouselSpeed;

            value = BrowserStorage.getItem('showUnitLogo');
            this.showUnitLogo = value ? value == 'true' : true;
            this.editShowUnitLogo = this.showUnitLogo;

            value = BrowserStorage.getItem('showMask');
            this.showMask = value ? value == 'true' : true;
            this.editShowMask = this.showMask;

            value = BrowserStorage.getItem('maskOpacity');
            this.maskOpacity = value ? parseFloat(value) : 0.5;
            this.editMaskOpacity = this.maskOpacity;

            value = BrowserStorage.getItem('scoreIntervalTime');
            this.scoreIntervalTime = value ? parseInt(value) : 3000;
            this.editScoreIntervalTime = this.scoreIntervalTime;

            value = BrowserStorage.getItem('themeColor');
            this.themeColor = value ? value : '#0030b3';
            this.editThemeColor = this.themeColor;

            value = BrowserStorage.getItem('matchTitleFontSize');
            this.matchTitleFontSize = value ? parseInt(value) : 50;
            this.editMatchTitleFontSize = this.matchTitleFontSize;

            value = BrowserStorage.getItem('proTitleFontSize');
            this.proTitleFontSize = value ? parseInt(value) : 30;
            this.editProTitleFontSize = this.proTitleFontSize;

        },
        getAllMatchs() {
            MatchService.selectMatchListByName({
                matchName: "",
                signupStatus: "",
                matchStatus: "",
            }).then((res) => {
                if (res.code == 0) {
                    this.allMatchs = res.data;
                    this.matchOptions = this.allMatchs;
                    this.match = this.allMatchs.find(
                        (a) => a.MatchId == this.routeMatchId
                    );
                }
            });
        },
        calcSpeedDivMaxWidth(num) {
            this.speedDivWidth = '100%';
            // if (num == 1) {
            //     this.speedUserItemDivWidth = '50%';
            //     this.speedDivWidth = '33%';
            // } else if (num == 2) {
            //     this.speedDivWidth = '70%';
            //     this.speedUserItemDivWidth = '50%';
            // } else if (num == 3) {
            //     this.speedUserItemDivWidth = '30%';
            // } else if (num == 4) {
            //     this.speedUserItemDivWidth = '25%';
            // } else if (num == 5) {
            //     this.speedUserItemDivWidth = '20%';
            // } else if (num > 5 && num < 10) {
            //     this.speedUserItemDivWidth = 100 / num + '%';
            // }
            // else {
            //     this.speedUserItemDivWidth = '10%';
            // }
        },

        userScorePage(arr) {
            const pages = [];
            const pageSize = 12;

            if (arr.length <= 12) {
                this.calcSpeedDivMaxWidth(arr.length);
                return [arr];
            }

            for (let i = 0; i < arr.length; i += pageSize) {
                pages.push(arr.slice(i, i + pageSize));
            }
            return pages;
        },

        userScorePage2(arr) {
            const pages = [];
            const pageSize = 6;
            this.speedDivWidth = '100%';
            this.speedUserItemDivWidth = '33%';
            if (arr.length == 2 || arr.length == 4) {
                this.speedDivWidth = '70%';
                this.speedUserItemDivWidth = '50%';
            }


            if (arr.length <= 6) {
                //this.calcSpeedDivMaxWidth(arr.length);
                return [arr];
            }

            for (let i = 0; i < arr.length; i += pageSize) {
                pages.push(arr.slice(i, i + pageSize));
            }




            return pages;
        },

        getMatchDetail() {

            if (this.routerMatchId) {
                MatchService.getMatchDetail({ matchId: this.routerMatchId }).then(res => {
                    if (res.code == 0) {
                        this.match = res.data;
                        this.matchName = this.match.MatchName; //赛事名称使用对象时v-if判断会有问题，未知原因
                        if (this.match.ScoreLargeScreenBackGroundImageFile) {
                            this.bgImageUrl = this.fileRootPath + this.match.ScoreLargeScreenBackGroundImageFilePath;
                        }
                        let rid = this.$route.params.rid;
                        if (rid) {
                            this.routerRegionId = rid;
                            this.getCurrMatchRegionUserScore();
                        } else {
                            this.showChoiceMatchDialog();
                        }
                    }
                })
            }

        },
        remoteMethod() {
            if (query !== "") {
                this.matchOptions = this.allMatchs.filter((item) => {
                    return item.MatchName.indexOf(query) > -1;
                });
            } else {
                this.matchOptions = this.allMatchs;
            }
        },
        showChoiceMatchDialog() {
            this.matchId = this.routerMatchId;
            this.regionId = this.routerRegionId;

            if (this.matchId && this.allMatchs) {
                let match = this.allMatchs.find(a => a.MatchId == this.matchId);
                this.regionOptions = match.Regions;
            }

            if (this.regionId == '' && this.regionOptions) {
                this.regionId = this.regionOptions[0].RegionId;
            }

            this.choiceMatchDialogVisible = true;
        },
        matchSelectChange(e) {
            console.log(e);
            let match = this.allMatchs.find(a => a.MatchId == e);
            this.regionOptions = match.Regions;
            this.regionId = this.regionOptions[0].RegionId;
        },
        confirmChoiceMatch() {
            BrowserStorage.setItem('carouselSpeed', this.editCarouselSpeed);
            BrowserStorage.setItem('showUnitLogo', this.editShowUnitLogo);
            BrowserStorage.setItem('showMask', this.editShowMask);
            BrowserStorage.setItem('maskOpacity', this.editMaskOpacity);
            BrowserStorage.setItem('scoreIntervalTime', this.editScoreIntervalTime);
            BrowserStorage.setItem('themeColor', this.editThemeColor);
            BrowserStorage.setItem('matchTitleFontSize', this.editMatchTitleFontSize);
            BrowserStorage.setItem('proTitleFontSize', this.editProTitleFontSize);


            this.showUnitLogo = this.editShowUnitLogo;
            this.carouselSpeed = this.editCarouselSpeed;
            this.showMask = this.editShowMask;
            this.maskOpacity = this.editMaskOpacity;
            this.scoreIntervalTime = this.editScoreIntervalTime;
            this.themeColor = this.editThemeColor;
            this.matchTitleFontSize = this.editMatchTitleFontSize;
            this.proTitleFontSize = this.editProTitleFontSize;



            if (this.matchId != "" && this.matchId != this.routeMatchId && this.regionId != '' && this.regionId != this.routerRegionId) {
                this.$router.replace("/match-referee-score-view/" + this.matchId + '/' + this.regionId);
            }
            this.choiceMatchDialogVisible = false;
        },
        startPollGetUserScore() {
            if (this.interval == null) {
                setInterval(() => {
                    this.getCurrMatchRegionUserScore();
                }, this.scoreIntervalTime);
            }
        },
        stopPollGetUserScore() {
            if (this.interval) {
                clearInterval(this.interval)
                this.interval = null;
            }
        },
        getCurrMatchRegionUserScore() {
            if (this.routerMatchId && this.routerRegionId) {
                MatchService.getCurrMatchRegionUserScore({ matchId: this.routerMatchId, regionId: this.routerRegionId }).then(res => {
                    if (res.code == 0) {
                        if (res.data == null) {
                            this.project = null;
                            this.userScores = [];
                            this.speechUserScore = [];
                        } else {
                             this.project = res.data.project;
                            if(this.isConnected && this.project.ProjectTypeId == 'F679B7E4-F852-4A2A-BAF2-EC21BE923826' && this.userScores.length > 0 && res.data.userScores && this.userScores[0].UserId == res.data.userScores[0].UserId) return;

                           
                            this.userScores = res.data.userScores;
                            if (this.project.ProjectTypeId == 'F679B7E4-F852-4A2A-BAF2-EC21BE923826'
                                || this.project.ProjectTypeId == '7427106A-8F3D-4990-803E-C10B92ED618F'
                                || this.project.ProjectTypeId == 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3') {
                                    
                                if (this.userScores.length >= 12 && this.userScores.length % 12 > 0) {
                                    let remainder = this.userScores.length % 12;
                                    // for (let index = 1; index <= (12 - remainder); index++) {
                                    //     this.userScores.push({
                                    //         UserId: '',
                                    //         UserName: '',
                                    //         Unit: '',
                                    //         ComeOnGroup: 0,
                                    //         ComeOnNum: 0,
                                    //         ProjectId: '',
                                    //     })
                                    // }
                                }
                                this.speechUserScore = this.userScorePage(this.userScores);
                            }
                            else if (this.project.ProjectTypeId == 'A8CF0C94-4A2B-495C-8E4C-861357928917'
                                || this.project.ProjectTypeId == 'B5F1B35F-FD39-4F5D-83CA-9972A21BC8C1'
                                || this.project.ProjectTypeId == 'FA8BBD50-62E3-47A0-A611-F70D34F29A67') {
                                if (this.userScores.length > 6 && this.userScores.length % 6 > 0) {
                                    let remainder = this.userScores.length % 6;
                                    for (let index = 1; index <= (6 - remainder); index++) {
                                        this.userScores.push({
                                            UserId: '',
                                            UserName: '',
                                            Unit: '',
                                            ComeOnGroup: 0,
                                            ComeOnNum: 0,
                                            ProjectId: '',
                                        })
                                    }
                                }
                                this.speechUserScore = this.userScorePage2(this.userScores);
                            }
                            else {
                                this.calcSpeedDivMaxWidth(this.userScores.length)
                            }

                        }
                    }
                })
            }
        }

    }
}
</script>

<style lang="scss">
.main {

    position: absolute;
    width: 100%;
    height: 100%;
    background: url('../../../assets/images/screen-mirroring-bg.png') no-repeat center center fixed;
    background-size: 100% 100%;
    overflow: hidden;
    overflow-y: auto;
    z-index: 1;

    .mask-div {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0);
        opacity: 0;
        z-index: 2;
    }

    .content-div {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 3;

        .match-title-div {
            position: relative;
            display: flex;
            height: 90px;
            // text-align: center;
            align-items: center;
            /* 垂直居中 */
            margin: 1% auto 0;
            width: 95%;

            .match-title {
                position: relative;
                width: 100%;
                font-size: 50px;
                color: #fff;
                font-family: 'PangMenChenDao', sans-serif;
                text-align: center;
            }
        }

        .project-info-div {
            position: relative;
            width: 100%;
            font-size: 30px;
            color: #fff;
            font-family: 'OPPOSans M', sans-serif;
            text-align: center;
            height: 80px;
            line-height: 80px;
            margin-top: 50px;

            .order-info {
                padding: 5px 10px;
                background-color: var(--themeColor);
                margin-right: 20px;
                border-radius: 5px;
            }
        }

        .user-score-div {
            // width: 90%;
            margin: 0% auto 0;
            height: 800px;
            border-radius: 20px;
            padding-bottom: 30px;
            box-sizing: border-box;

            .pattern-div {
                display: flex;
                height: 100%;
                width: 1200px;
                background-color: #fff;
                border-radius: 20px;
                margin: 0 auto;

                .user-info {
                    position: relative;
                    width: 30%;
                    height: 100%;

                    .image-div {
                        width: 200px;
                        height: 200px;
                        margin: 50px auto 50px;

                        img {
                            width: 100%;
                            height: 100%;
                            border-radius: 100px;
                        }
                    }

                    .unit-div {
                        width: 80%;
                        text-align: center;
                        margin: 0 auto;
                        margin-top: 20px;
                        font-size: 28px;
                        color: var(--themeColor);
                        min-height: 32px;
                        font-family: 'OPPOSans B', sans-serif;
                        word-break: break-all;
                        /* 强制在任意字符处换行 */
                        word-wrap: break-word;
                        white-space: normal;
                    }

                    .username-div {
                        width: 80%;
                        text-align: center;
                        margin: 0 auto;
                        margin-top: 20px;
                        font-size: 22px;
                        font-family: 'OPPOSans M', sans-serif;
                    }

                    .group-div {
                        margin-top: 20px;
                        text-align: center;
                        font-size: 22px;

                        span {
                            padding: 6px 30px;
                            background-color: var(--themeColor);
                            height: 40px;
                            line-height: 40px;
                            color: #fff;
                            border-radius: 20px;
                        }
                    }
                }

                .score-group {
                    position: relative;
                    width: 37%;
                    height: 100%;
                    display: flex;
                    padding: 120px 80px;
                    box-sizing: border-box;
                    flex-wrap: wrap;

                    .score-group-item {
                        position: relative;
                        width: 50%;
                        height: 180px;
                        box-sizing: border-box;
                        text-align: center;
                        color: var(--themeColor);

                        .title {
                            height: 60px;
                            line-height: 60px;
                            font-size: 22px;
                            font-family: 'OPPOSans B', sans-serif;
                        }

                        .value {
                            height: 120px;
                            line-height: 120px;
                            font-size: 40px;
                            font-family: 'OPPOSans B', sans-serif;
                        }
                    }
                }

                .score-result {
                    position: relative;
                    width: 30%;
                    height: 100%;

                    .title {
                        margin-top: 120px;
                        text-align: center;
                        font-size: 50px;
                        height: 150px;
                        line-height: 150px;
                    }

                    .score-num {
                        text-align: center;
                        width: 90%;
                        margin: 20px auto;
                        background-color: var(--themeColor);
                        color: #fff;
                        font-size: 85px;
                        height: 180px;
                        line-height: 180px;
                        border-radius: 30px;
                        font-family: 'OPPOSans B', sans-serif;
                    }
                }
            }

            .pattern-div2 {
                display: flex;
                height: 100%;
                width: 1200px;
                background-color: #fff;
                // border-radius: 20px;
                margin: 100px auto 0px;

                .left-div {
                    width: 65%;
                    height: 100%;

                    .group-div {
                        margin-bottom: 20px;
                        font-size: 22px;

                        span {
                            padding: 10px 50px;
                            background-color: var(--themeColor);
                            height: 40px;
                            line-height: 40px;
                            color: #fff;
                            // border-top-left-radius: 20px;
                        }
                    }

                    .user-info {
                        position: relative;
                        display: flex;
                        margin-top: 60px;

                        .image-div {
                            width: 200px;
                            height: 200px;
                            margin: 0 50px 50px;

                            img {
                                width: 100%;
                                height: 100%;
                                border-radius: 100px;
                            }
                        }

                        .text-div {
                            width: calc(100% - 250px);

                            .unit-div {
                                margin: 0 auto;
                                margin-top: 20px;
                                font-size: 28px;
                                color: var(--themeColor);
                                min-height: 32px;
                                font-family: 'OPPOSans B', sans-serif;
                                word-break: break-all;
                                /* 强制在任意字符处换行 */
                                word-wrap: break-word;
                                white-space: normal;
                            }

                            .username-div {
                                margin: 0 auto;
                                margin-top: 20px;
                                font-size: 22px;
                                font-family: 'OPPOSans M', sans-serif;
                            }
                        }
                    }

                    .score-group {
                        display: flex;
                        margin-top: 20px;

                        .score-group-item {
                            position: relative;
                            // width: 25%;
                            flex-grow: 1;
                            height: 180px;
                            box-sizing: border-box;
                            text-align: center;
                            color: var(--themeColor);

                            .title {
                                height: 60px;
                                line-height: 60px;
                                font-size: 22px;
                                font-family: 'OPPOSans B', sans-serif;
                            }

                            .value {
                                height: 120px;
                                line-height: 120px;
                                font-size: 40px;
                                font-family: 'OPPOSans B', sans-serif;
                            }
                        }
                    }
                }

                .right-div {
                    width: 30%;
                    height: 100%;

                    .score-result {
                        position: relative;
                        height: 100%;

                        .title {
                            margin-top: 120px;
                            text-align: center;
                            font-size: 50px;
                            height: 150px;
                            line-height: 150px;
                        }

                        .score-num {
                            text-align: center;
                            width: 90%;
                            margin: 20px auto;
                            background-color: var(--themeColor);
                            color: #fff;
                            font-size: 85px;
                            height: 180px;
                            line-height: 180px;
                            border-radius: 30px;
                            font-family: 'OPPOSans B', sans-serif;
                        }
                    }
                }
            }

            .speed-div {
                width: 100%;
                display: flex;
                position: relative;
                // justify-content: space-between;
                overflow: hidden;
                overflow-x: auto;
                overflow-y: auto;
                white-space: nowrap;
                margin: 20px auto 0;
                flex-wrap: wrap;
                align-items: center;

                /* 子项垂直居中 */
                .user-item {
                    position: relative;
                    // flex: 1;
                    // text-align: center;


                    .user-score-detail {
                        position: relative;
                        width: 95%;
                        height: 230px;
                        margin: 5px auto;
                        border-radius: 5px;
                        padding: 0px 0 5px;
                        box-sizing: border-box;
                        background-color: #fff;

                        .group-div {
                            width: 100%;
                            margin-top: 10px;
                            font-size: 18px;
                            background-color: var(--themeColor);
                            border-top-left-radius: 5px;
                            border-top-right-radius: 5px;

                            span {
                                padding: 6px 20px;

                                height: 40px;
                                line-height: 40px;
                                color: #fff;
                                border-radius: 20px;
                            }
                        }

                        .unit-div {
                            width: 100%;
                            margin: 0 auto;
                            margin-top: 10px;
                            font-size: 14px;
                            color: var(--themeColor);
                            padding: 0 10px;
                            min-height: 36px;
                            box-sizing: border-box;
                            font-family: 'OPPOSans B', sans-serif;
                            white-space: nowrap;
                            /* 防止文本换行 */
                            overflow: hidden;
                            /* 隐藏溢出的内容 */
                            text-overflow: ellipsis;
                            /* 显示省略号 */
                            word-wrap: break-word;
                            white-space: normal;

                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                        }

                        .user-score-detail-body {
                            display: flex;

                            .user-detail {
                                width: 70%;

                                .username-div {
                                    width: 100%;
                                    text-align: center;
                                    margin: 0 auto;
                                    margin-top: 3px;
                                    font-size: 12px;
                                    max-height: 50px;
                                    min-height: 50px;
                                    padding: 0 10px;
                                    box-sizing: border-box;
                                    font-family: 'OPPOSans M', sans-serif;
                                    word-break: break-all;
                                    /* 强制在任意字符处换行 */
                                    word-wrap: break-word;
                                    white-space: normal;
                                }
                            }

                            .score-num-div {
                                text-align: center;
                                width: 23%;
                                margin: 10px auto;
                                background-color: var(--themeColor);
                                color: #fff;
                                font-size: 26px;
                                height: 70px;
                                line-height: 70px;
                                border-radius: 8px;
                                font-family: 'OPPOSans B', sans-serif;

                            }
                        }


                        // .image-div {
                        //     text-align: center;
                        //     position: relative;
                        //     margin: 0 auto;
                        //     width: 200px;
                        //     height: 200px;

                        //     img {
                        //         position: relative;
                        //         width: 90%;
                        //         height: 90%;
                        //         border-radius: 50%;
                        //     }
                        // }



                    }
                }
            }

            .rule-div {
                width: 100%;
                text-align: center;
                font-size: 14px;
                color: var(--themeColor);
                width: 100%;
                display: flex;
                position: relative;
                justify-content: space-between;
                overflow: hidden;
                overflow-x: auto;
                white-space: nowrap;
                margin: 0 auto;
                flex-wrap: wrap;
                align-items: center;
                padding-top: 50px;

                /* 子项垂直居中 */
                .user-item {
                    position: relative;
                    // flex: 1;
                    height: 100%;
                    min-height: 100%;
                    text-align: center;
                    min-width: 10%;
                    margin-bottom: 20px;
                    margin: 20 auto;

                    .user-score-detail {
                        position: relative;
                        width: 95%;
                        margin: 5px auto;
                        background-color: #fff;
                        border-radius: 5px;
                        padding: 10px;
                        box-sizing: border-box;

                        .user-info {
                            width: 30%;

                            .unit-div {
                                width: 100%;
                                text-align: center;
                                margin: 0 auto;
                                margin-top: 10px;
                                font-size: 16px;
                                color: var(--themeColor);
                                padding: 0 10px;
                                min-height: 32px;
                                box-sizing: border-box;
                                font-family: 'OPPOSans B', sans-serif;
                                white-space: nowrap;
                                /* 防止文本换行 */
                                overflow: hidden;
                                /* 隐藏溢出的内容 */
                                text-overflow: ellipsis;
                                /* 显示省略号 */
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                            }

                            .username-div {
                                width: 100%;
                                text-align: center;
                                margin: 0 auto;
                                margin-top: 3px;
                                font-size: 12px;
                                max-height: 100px;
                                // min-height: 60px;
                                padding: 0 10px;
                                box-sizing: border-box;
                                font-family: 'OPPOSans M', sans-serif;
                                word-break: break-all;
                                /* 强制在任意字符处换行 */
                                word-wrap: break-word;
                                white-space: normal;
                            }

                            .group-div {
                                margin-top: 20px;
                                text-align: center;
                                font-size: 14px;

                                span {
                                    padding: 6px 20px;
                                    background-color: var(--themeColor);
                                    height: 40px;
                                    line-height: 40px;
                                    color: #fff;
                                    border-radius: 20px;
                                }
                            }
                        }

                        .score-item-div {
                            width: 70%;
                            display: flex;
                            align-items: center;
                            padding: 10px 0;
                            box-sizing: border-box;
                            font-size: 14px;
                            color: var(--themeColor);
                            font-family: 'OPPOSans M', sans-serif;

                            .score-item {
                                width: 40%;
                                text-align: center;
                                border-radius: 20px;
                                font-family: 'OPPOSans B', sans-serif;

                                p {
                                    height: 40px;
                                    line-height: 40px;
                                    font-size: 18px;
                                }

                                .score-num-div {
                                    text-align: center;
                                    width: 95%;
                                    margin: 10px auto;
                                    background-color: var(--themeColor);
                                    color: #fff;
                                    font-size: 26px;
                                    height: 50px;
                                    line-height: 50px;
                                    border-radius: 8px;
                                    font-family: 'OPPOSans B', sans-serif;
                                }
                            }

                        }



                    }
                }
            }

            /* 自定义滚动条样式 */
            .speed-div::-webkit-scrollbar {
                height: 10px;
                /* 滚动条高度 */
            }

            .speed-div::-webkit-scrollbar-track {
                background: transparent;
                /* 滚动条轨道颜色 */
            }

            .speed-div::-webkit-scrollbar-thumb {
                background: transparent;
                /* 滚动条滑块颜色 */
                border-radius: 4px;
                /* 滑块圆角 */
            }

            .speed-div::-webkit-scrollbar-thumb:hover {
                background: #555;
                opacity: 0.4;
                /* 滑块悬停颜色 */
            }
        }
    }
}

// .el-carousel__container {
//     height: 700px;
// }
</style>
